/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Quotes/Quotes',[
    'jquery',
    'lodash',
    'global/all',
    './../Cart/CartLocker',
    './QuotesService'
], function ($, _, Roc, CartLocker, QuotesService) {
    'use strict';
    var cartPageUrl;
    var quotesPerPage = 10;
    var lastPage = 1;
    var currentPage = 1;

    var elements = {
        quotesWrapper: '#quotesWrapper',
        quoteDetailsBtn: '[data-roc-action="viewDetails"]',
        orderQuoteBtn: '.orderQuoteBtn',
        searchBar: {
            searchBtn: '#quotesSearchBtn',
            period: '#periodSelect',
            quoteNo: '#quoteNoInput',
            sortOrder: '#sortOrderSelect'
        },
        paging: {
            nextPage: "#nextQuotePage",
            prevPage: "#prevQuotePage",
            pageTextBox: "#quotePageTextBox"
        }
    };

    function searchAndRender(pageNum) {
        var searchDate = $(elements.searchBar.period).val();
        var quoteNo = $(elements.searchBar.quoteNo).val();
        var sortOrder = $(elements.searchBar.sortOrder).val();
        Roc.UI.block(elements.quotesWrapper);
        QuotesService.getAvailable({
                page: pageNum,
                itemsOnPage: quotesPerPage,
                sortBy: sortOrder,
                SearchDate: searchDate,
                quoteNo: quoteNo
            })
            .then(function(availableQuotes) {
                setPagingInfo(availableQuotes);
                Roc.UI.template('quotes-Tmp', availableQuotes)
                    .then(function(rendererdTemplate) {
                        $(elements.quotesWrapper).html(rendererdTemplate);
                    });
            })
            .fail(function (xhr) {
                if (xhr.responseJSON && xhr.responseJSON.message) {
                    Roc.UI.displayErrorPopup(xhr.responseJSON.message);
                } else {
                    Roc.UI.displayErrorPopup("Error occured while searching for quotes");
                }
            })
            .always(function() {
                Roc.UI.unblock(elements.quotesWrapper);
            });
    }

    function toggleDetailsBtnText(btn) {
        if (btn.hasClass('collapsed')) {
            btn.text('Details');
        } else {
            btn.text('Collapse');
        }
    }

    function setPagingInfo(availableQuotes) {
        availableQuotes.totalPages = Math.ceil(availableQuotes.totalItems / quotesPerPage);
        availableQuotes.startIndex = (availableQuotes.currentPage - 1) * quotesPerPage + 1;
        availableQuotes.endIndex = (availableQuotes.currentPage - 1) * quotesPerPage + availableQuotes.quotes.length;
        lastPage = availableQuotes.totalPages;
        currentPage = availableQuotes.currentPage;
    }

    function searchEvt() {
        $(document)
            .on('click',
                elements.searchBar.searchBtn,
                function() {
                    searchAndRender(1);
                });
    }

    function viewQuoteDetailsEvt() {
        $(document).on('click', elements.quoteDetailsBtn, function() {
            toggleDetailsBtnText($(this));
            var quoteId = $(this).attr('data-id');
            var targetSelector = $(this).attr('data-target');
            if ($.trim($(targetSelector).text()).length === 0) {
                Roc.UI.block(targetSelector);
                QuotesService.getQuoteDetails(quoteId)
                    .then(function(details) {
                        Roc.UI.template('quoteDetails-Tmp', details)
                            .then(function(renderedTemplate) {
                                $(targetSelector).html(renderedTemplate);
                            });
                    })
                    .fail(function() {
                        Roc.UI.displayErrorPopup("Could not retrieve quote details");
                    })
                    .always(function () {
                        Roc.UI.unblock(targetSelector);
                    });
            }
        });
    }

    function pageEvts() {
        $(document)
            .on('click',
                elements.paging.nextPage,
                function () {
                    var pageNum = parseInt($(elements.paging.pageTextBox).val());
                    if (pageNum < lastPage) {
                        searchAndRender(pageNum + 1);
                    }
                });
        $(document)
            .on('click',
                elements.paging.prevPage,
                function () {
                    var pageNum = parseInt($(elements.paging.pageTextBox).val());
                    if (pageNum > 1) {
                        searchAndRender(pageNum - 1);
                    }
                });
        $(document)
            .off('change', elements.paging.pageTextBox)
            .on('change', elements.paging.pageTextBox, function () {
                var pageNum = parseInt($(this).val());
                if (pageNum <= lastPage && pageNum >= 1) {
                    searchAndRender(pageNum);
                } else {
                    $(this).val(currentPage);
                }
            });
    }

    function orderQuoteEvt() {
        $(document)
            .on('click',
                elements.orderQuoteBtn,
                function (e) {
                    var quoteId = $(this).attr('data-id');
                    Roc.UI.confirm('Are you sure you want to replace current cart with quote items?',
                        function () {
                            Roc.Core.lockButton(e.currentTarget);
                            QuotesService.loadQuote(quoteId)
                                .then(function (response) {
                                    if (response.message) {
                                        Roc.UI.displayErrorPopup(response.message);
                                    } else {
                                        CartLocker.lockCart();
                                        window.location = cartPageUrl;
                                    }
                                })
                                .fail(function () {
                                    Roc.UI.displayErrorPopup("Could not load quote to cart");
                                })
                                .always(function () {
                                    Roc.Core.releaseLockedButton(e.currentTarget);
                                });
                        });
                });
    }

    function bindEvents() {
        searchEvt();
        pageEvts();
        viewQuoteDetailsEvt();
        orderQuoteEvt();
    };

    function init(options) {
        cartPageUrl = options.cartUrl;
        searchAndRender(1);
        bindEvents();
    };

    var Quotes = {
        init: init
    };

    Roc.Logger.debug('Quotes.js Loaded:', Quotes);

    return Quotes;
});
